import { CustomIcon } from '../../../icons/types';

const Map: CustomIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    className={className}
  >
    <path
      d="M20.334 14C20.334 16.2091 18.5431 18 16.334 18C14.1248 18 12.334 16.2091 12.334 14C12.334 11.7909 14.1248 10 16.334 10C18.5431 10 20.334 11.7909 20.334 14Z"
      stroke="#38393A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.334 14C26.334 23.5228 16.334 29 16.334 29C16.334 29 6.33398 23.5228 6.33398 14C6.33398 8.47715 10.8111 4 16.334 4C21.8568 4 26.334 8.47715 26.334 14Z"
      stroke="#38393A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Map;
